//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'document'
let resource_name = 'documento'
let resource_name_plural = 'documentos'

let state = {
  documents: []
}

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      let res = await Vue.request.get(`llmparse/${params.accountId}/${resource}s/${params.accountId}`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`llmparse/${params.accountId}/${resource}s/${params.id}/data`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`llmparse/${params.accountId}/scraper/file`, params)
      if(res.data.success && params.callback) {
        commit('pushItem', {id: res.data.resource, ...params})
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async createLink ({ commit }, params) {
    try {
      let res = await Vue.request.post(`llmparse/${params.accountId}/scraper/link`, params)
      if(res.data.success && params.callback) {
        commit('pushItem', {id: res.data.resource, ...params})
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando enlace.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando enlace.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`llmparse/${params.accountId}/scraper/file/${params.id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async updateLink ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`llmparse/${params.accountId}/scraper/link/${params.id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando enlace.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando enlace.`})
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`llmparse/${params.accountId}/scraper/file/${params.id}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeItem', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando ${resource_name}.`})
      console.error(e)
    }
  },
  async destroyLink ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`llmparse/${params.accountId}/scraper/link/${params.id}`, {data: params})
      if(res.data.success && params.callback) {
        commit('removeItem', params)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando enlace.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando enlace.`})
      console.error(e)
    }
  },
  async updateNode ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`llmparse/${params.account_id}/documents/node/${params.id}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando contenido de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando contenido de ${resource_name}.`})
      console.error(e)
    }
  },
  async destroyNode ({ commit }, params) {
    try {
      let res = await Vue.request.delete(`llmparse/${params.accountId}/documents/node/${params.id}`, {data: params})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error eliminando contenido de ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error eliminando contenido de ${resource_name}.`})
      console.error(e)
    }
  },
  async addFilter (
    { commit },
    { account_id, doc_id, type, params = {}, callback = () => {} }
  ) {
    try {
      const res = await Vue.request.post(
        `llmparse/${account_id}/scraper/model/${doc_id}/filter?type=${type}`,
        { Filters: params.Filters }
      )

      const { data } = res

      if (!data.success) throw new Error('Ocurrió un error agregando el filtro')

      return callback(data)
    } catch (e) {
      console.error(e)

      const data = { error: e.message }

      return callback(data)
    }
  },
  async removeFilter (
    { commit },
    { account_id, doc_id, type, filter_id, params = {}, callback = () => {} }
  ) {
    try {
      const res = await Vue.request.delete(
        `llmparse/${account_id}/scraper/model/${doc_id}/filter/${filter_id}?type=${type}`
      )
      const { data } = res

      if (!data.success) throw new Error('Ocurrió un error eliminando el filtro')

      return callback(data)
    } catch (e) {
      console.error(e)

      const data = { error: e.message }

      return callback(data)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state.documents = items
  },
  pushItem(state, item) {
    state.documents.push(item)
  },
  removeItem(state, item) {
    let index = state.documents.findIndex(el => el.id === item.id)
    if(index >= 0) {
      state.documents.splice(index, 1)
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
